<template>
  <div>
    <Nav className="navbar navbar-default navbar-mobile navbar-fixed light bootsnav" />
    <JobBanner title="" desc="" />
    <JobDetail v-if="job.id" :job="job" :jobs="jobs" @apply-job="handleApplyJob" />
    <Footer :functions="meta.active_functions" />
    <FollowModal />
    <ApplyModal :jobId="jobId" :isMagex="job.isMagex" :config="job.config" :email="applyEmail" :isExternal="job.isExternal"/>
    <SubscribeModal />
  </div>
</template>

<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import JobBanner from '@/components/JobBanner.vue'
import JobDetail from '@/components/JobDetail.vue'
import Footer from '@/components/Footer.vue'
import FollowModal from '@/components/FollowModal.vue'
import ApplyModal from '@/components/ApplyModal.vue'
import SubscribeModal from '@/components/SubscribeModal.vue'
import jobStyle from '@/utils/job-style'

export default {
  name: 'detail',
  props: ['meta', 'config'],
  components: {
    Nav,
    JobBanner,
    JobDetail,
    Footer,
    FollowModal,
    ApplyModal,
    SubscribeModal
  },
  data: () => ({
    jobs: [],
    job: {},
    applyEmail: ''
  }),
  watch: {
    jobId: function() {
      this.updateJob()
    }
  },
  computed: {
    jobId: function() {
      return this.$route.params.id
    },
    isHR: function() {
      return this.$route.query.s === '1'
    }
  },
  methods: {
    handleApplyJob(data) {
      this.applyEmail = data.email
      this.$nextTick(() => {
        $('#apply-job').modal('show')
      })
    },
    getConfig: function(v) {
      return jobStyle.getConfig(v, this.config)
    },
    updateJob: function() {
      let that = this,
        url = this.isHR ? this.API_PREFIX + '/api2/job/' : this.API_PREFIX + '/api/job/',
        url1 = this.isHR ? this.API_PREFIX + '/api2/search/job' : this.API_PREFIX + '/api/search/job'

      this.$http.get(url + this.jobId).then(function (response) {
        //console.log(response)
        that.job = response.data
        that.normalizeName(that.job.title)
        if(that.job.client_company)
          that.normalizeCompany(that.job.client_company.name)

        if (that.job.genes != null) {
          if (that.job.genes.client_company != null && that.job.genes.client_company.includes('Rz'))
            that.job.featured = true
          if (that.job.genes.client_company != null && that.job.genes.client_company.includes('Qk'))
            that.job.internFlag = true
          if (that.job.genes.hirer != null && that.job.genes.hirer.includes('qN'))
            that.job.isMagex = true
        }

        if (that.job.genes != null) {
          //console.log(that.getConfig(job.data))
          that.job.config = that.getConfig(that.job)
        }

        if(that.job.extra && that.job.extra.apply_url) {
          const robustRegex = /^https?:\/\/([\w-]+\.)+[\w-]+(:\d+)?(\/\S*)?$/i;
          if(robustRegex.test(that.job.extra.apply_url)){
            that.job.isExternal = true
          }
        }

        let functionId = that.job.job_function.function_group_id
        let filter = {
          options: {
            page: 0,
            size: 9,
            sort: [{ id: 'desc' }]
          },
          query: {
            mandatory_filters: [{"type":"must","filter":{"or":[{"term":{"status":0}},{"term":{"status":1}}]}}],
            optional_filters:[{"boost":9,
             "filter":{"query":{"query_string":{"query": encodeURI(that.job.title.name)
             }}}}]
          }
        }
        filter.query.mandatory_filters.push({
          type: 'must',
          filter: {
            or: [
              { term: { 'job_function.id': functionId }},
              { term: { 'job_function.function_id': functionId }},
              { term: { 'job_function.function_group_id': functionId }}
            ]
          }
        })

        that.$http.post(url1, filter).then(function (response) {
          that.jobs = response.data.hits
          that.jobs.forEach(function(job, i) {
            that.normalizeName(job.data.title)
            if (job.data.recruiting_company)
              that.normalizeCompany(job.data.recruiting_company.name)
            let img = '/img/no-logo.heic',
              photo = null
            if (job.data.recruiting_company)
              photo = job.data.recruiting_company.photo
            else
              job.data.recruiting_company = {'photo_url': null, 'photo': null, 'id': null, 'name': {'name': null}}
            if (photo) {
              let ext = photo.filename.substr(photo.filename.lastIndexOf('.') + 1)
              img = that.IMG_PREFIX + photo.path + '/' + photo.id + '_company_photo_m.' + ext + '?r=' + Math.random()
            }
            job.data.recruiting_company.photo_url = img

            if (job.data.genes != null) {
              if (job.data.genes.client_company != null && job.data.genes.client_company.includes('Rz'))
                job.data.featured = true
              if (job.data.genes.client_company != null && job.data.genes.client_company.includes('Qk'))
                job.data.internFlag = true
              if (job.data.genes.hirer != null && job.data.genes.hirer.includes('qN'))
                job.data.isMagex = true
            }
            if (job.data.genes != null) {
              //console.log(that.getConfig(job.data))
              job.data.config = that.getConfig(job.data)
            }

          })
        }).catch(function (error) {
          console.log(error)
        });
        
      }).catch(function (error) {
        console.log(error)
      });
    }
  },
  mounted: function() {
    
  },
  created: function() {
    if (this.isMobile()) {
      //window.location = 'https://www.accacnjobs.com/#/vacancy.html?id=' + this.jobId
    }
    this.updateJob()
  }
}
</script>